export default __webpack_public_path__ + "static/media/b9-med.4debd61f.jpg";